<template>
  <div v-if="embedded" class="insure-panel">
    <div v-if="showToolbar" class="insure-panel__toolbar d-flex align-center justify-space-between mb-3">
      <div class="text-subtitle-1 font-weight-medium">投保操作</div>
      <wgu-measure-type-chooser :insureType="insureType" :showAngleTool="showAngleTool" :iconsOnly="iconsOnly"
        @ks-insuretype-change="applyInsureType" />
    </div>
    <ks-insure-result :measureGeom="measureGeom" :insureType="insureType" :trusteeLands="trusteeLands"
      :clickedPlotInfo="clickedPlotInfo" @submit="trusteeSubmit" @refreshTrusteeLands="handleRefreshTrusteeLands"
      @remove-trustee-land="handleRemoveTrusteeLand"
      @request-box-select-add="startBoxSelectAdd"
      @switch-to-marked="applyInsureType('markedPlot')"
      @request-draw-mode="$emit('request-draw-mode')"
      @request-search-mode="$emit('request-search-mode')" />
  </div>

  <wgu-module-card v-else v-bind="$attrs" :moduleName="moduleName" class="wgu-insurewin" :icon="icon"
    :minWidth="'450px'" v-on:visibility-change="show">
    <template v-slot:wgu-win-toolbar>
      <wgu-measure-type-chooser :insureType="insureType" :showAngleTool="showAngleTool" :iconsOnly="iconsOnly"
        @ks-insuretype-change="applyInsureType" />
    </template>

    <v-card-actions>
      <ks-insure-result :measureGeom="measureGeom" :insureType="insureType" :trusteeLands="trusteeLands"
        :clickedPlotInfo="clickedPlotInfo" @submit="trusteeSubmit" @refreshTrusteeLands="handleRefreshTrusteeLands"
        @remove-trustee-land="handleRemoveTrusteeLand"
        @request-box-select-add="startBoxSelectAdd"
        @request-draw-mode="$emit('request-draw-mode')"
        @request-search-mode="$emit('request-search-mode')" />
    </v-card-actions>
  </wgu-module-card>
</template>

<script>
import ModuleCard from './../modulecore/ModuleCard';
import { Mapable } from '../../mixins/Mapable';
import { WguEventBus } from '../../WguEventBus';
import InsureTypeChooser from './InsureTypeChooser';
import InsureResult from './InsureResult';
import OlInsureController from './OlInsureController';
import { Style, Stroke } from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import { unByKey } from 'ol/Observable';
import DragBox from 'ol/interaction/DragBox';
import Option from '../../const/Option.js';
import { mapState } from 'vuex';

export default {
  name: 'wgu-insuretool-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': ModuleCard,
    'wgu-measure-type-chooser': InsureTypeChooser,
    'ks-insure-result': InsureResult
  },
  mixins: [Mapable],
  props: {
    embedded: { type: Boolean, required: false, default: false },
    icon: { type: String, required: false, default: 'photo_size_select_small' },
    showAngleTool: { type: Boolean, required: false, default: false },
    iconsOnly: { type: Boolean, required: false, default: false },
    showToolbar: { type: Boolean, required: false, default: true },
    insureTypeOverride: { type: String, required: false, default: '' }
  },
  data () {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      moduleName: 'wgu-insuretool',
      measureGeom: null,
      insureType: 'searchPlot',
      dialog: false,
      dialogMsg: '',
      singleClickKey: null,
      insureLayer: null,
      selectedItem: {
        id: '',
        land_name: '',
        owner_name: '',
        address: '',
        area: '',
        crop_id: '',
        irrigation: '',
        seed_id: '',
        mature_days: '',
        fertilizer_id: '',
        pesticide_id: '',
        insured_id: '',
        insured_name: ''
      },
      trusteeLands: [],
      clickedPlotInfo: null,
      option: Option,
      policyInfo: null,
      dragBoxInteraction: null
    }
  },
  created () {
    this._onPopupAddToSearchList = this.onPopupAddToSearchList.bind(this)
    WguEventBus.$on('insure-apply-add-plot-to-search-list', this._onPopupAddToSearchList)
    if (this.insureTypeOverride) {
      this.insureType = this.insureTypeOverride
    }
  },
  beforeDestroy () {
    if (this._onPopupAddToSearchList) {
      WguEventBus.$off('insure-apply-add-plot-to-search-list', this._onPopupAddToSearchList)
      this._onPopupAddToSearchList = null
    }
    this.clearAllMapListeners();
    if (this.olMapCtrl) {
      this.olMapCtrl.destroy();
      this.olMapCtrl = undefined;
    }
  },
  destroy () {
    this.clearAllMapListeners();
    if (this.olMapCtrl) {
      this.olMapCtrl.destroy();
      this.olMapCtrl = undefined;
    }
  },
  watch: {
    insureTypeOverride (newVal) {
      if (!newVal) return
      if (newVal !== this.insureType) {
        this.applyInsureType(newVal, this.insureType)
      }
    },
    insureType () {
      if (!this.olMapCtrl) {
        return;
      }
      // reset old geom
      this.measureGeom = {};
      if (this.insureType === 'markedPlot') {
        // Clean up existing click handlers before adding new ones
        this.clearSingleClickListener();
        this.olMapCtrl.addInteraction('area', this.onMeasureVertexSet);
      } else {
        this.olMapCtrl.removeInteraction();
        this.onMapClickBound();
      }

      console.log(this.selectedArea, this.selectedYear);
    }
  },
  computed: {
    ...mapState(['selectedArea', 'selectedYear'])
  },
  methods: {
    /**
     * Clears the single click listener
     */
    clearSingleClickListener () {
      if (this.singleClickKey) {
        unByKey(this.singleClickKey);
        this.singleClickKey = null;
      }
    },
    /**
     * Clears all map listeners related to this component
     */
    clearAllMapListeners () {
      this.clearSingleClickListener();
      if (this.map && this.dragBoxInteraction) {
        this.map.removeInteraction(this.dragBoxInteraction);
        this.dragBoxInteraction = null;
      }
      // If we have access to the controller, clean up there as well
      if (this.olMapCtrl) {
        this.olMapCtrl.removeInteraction();
      }
    },
    /**
       * (Un-)Register map interactions when the visibility of the module changes.
       *
       * @param  {boolean} visible New visibility state
       */
    show (visible) {
      if (!this.olMapCtrl) {
        return;
      }
      if (visible && this.insureType === 'markedPlot') {
        // Clean up existing click handlers before adding new ones
        this.clearSingleClickListener();
        this.olMapCtrl.addInteraction('area', this.onMeasureVertexSet);
      } else {
        this.olMapCtrl.removeInteraction();
        if (visible && this.insureType === 'searchPlot') {
          this.onMapClickBound();
        }
      }
    },
    /**
       * Applies the changed measure value to this.insureType.
       * Called as callback of insureTypeChooser
       *
       * @param  {String} newinsureType New measure type
       * @param  {String} oldinsureType Old measure type
       */
    applyInsureType (newinsureType, oldinsureType) {
      this.insureType = newinsureType;
      this.$emit('insure-type-change', newinsureType)
    },
    /**
       * This function is executed, after the map is bound (see mixins/Mapable)
       */
    onMapBound () {
      // Clear any existing listeners that might be left over
      this.clearAllMapListeners();

      // TODO: Should we explicitly declare all attributes as props?
      this.olMapCtrl = new OlInsureController(this.map, this.$attrs);
      this.olMapCtrl.createMeasureLayer();

      if (this.insureType === 'markedPlot') {
        this.clearSingleClickListener();
        this.olMapCtrl.addInteraction('area', this.onMeasureVertexSet);
      } else {
        this.onMapClickBound();
      }
    },
    /**
       * This function is executed, after the map is bound (see mixins/Mapable)
       */
    onMapUnbound () {
      this.clearAllMapListeners();
      if (this.olMapCtrl) {
        this.olMapCtrl.destroy();
        this.olMapCtrl = undefined;
      }
    },
    /**
       * Callback function executed when user sets a measure point on the map.
       *
       * @param  {ol/geom/Geometry} geom The geometry object of the map
       */
    onMeasureVertexSet (geom) {
      // wrap geom into object, otherwise the injection into childs does
      // not work. Maybe the OL object does not feel changed for Vue
      console.log('onMeasureVertexSet', geom);
      this.measureGeom = {
        geom
      };
    },

    onMapClickBound () {
      if (this.insureType === 'searchPlot') {
        // Clear existing click handler before adding a new one
        this.clearSingleClickListener();

        // Then bind new click handler
        this.singleClickKey = this.map.on('singleclick', event => this.onPlotClick(event, this.sourceTile));
      }
    },
    /**
     * Get feature from WMS layer (fallback)
     */
    async getWmsFeature (coordinate) {
      if (!this.map) return null;

      const wmsLayer = this.map.getLayers().getArray().find(l => l.get('lid') === 'wms-plot-layer');
      if (!wmsLayer) return null;

      const view = this.map.getView();
      const resolution = view.getResolution();
      const projection = view.getProjection();

      const source = wmsLayer.getSource();
      if (!source || typeof source.getFeatureInfoUrl !== 'function') return null;

      const url = source.getFeatureInfoUrl(
        coordinate,
        resolution,
        projection,
        { INFO_FORMAT: 'application/json', FEATURE_COUNT: 1 }
      );

      if (url) {
        try {
          // Use credentials from other parts of the app
          const credentials = btoa('data_services:data_services');
          const response = await fetch(url, {
            headers: {
              Authorization: `Basic ${credentials}`
            }
          });
          const data = await response.json();
          if (data && data.features && data.features.length > 0) {
            return new GeoJSON().readFeature(data.features[0]);
          }
        } catch (error) {
          console.error('Failed to get WMS feature info:', error);
        }
      }
      return null;
    },

    /**
     * Callback function executed when user clicks on the map.
     * Replaced WMS GetFeatureInfo with Vector Layer Feature Detection
     *
     * @param  {ol/MapBrowserEvent} e The map browser event
     */
    async onPlotClick (e) {
      const self = this;
      if (!self.map) return;

      const pixel = self.map.getEventPixel(e.originalEvent);

      // Hit detection on the plots-layer
      const clickableLayerIds = ['plots-layer', 'insured-plots-layer', 'uninsured-plots-layer', 'plot-boundaries-layer'];
      let feature = self.map.forEachFeatureAtPixel(
        pixel,
        (feat) => feat,
        {
          hitTolerance: 8,
          layerFilter: (layer) => {
            if (!layer || typeof layer.get !== 'function') return false;
            const lid = layer.get('lid');
            return clickableLayerIds.includes(lid);
          }
        }
      );

      // Fallback: Check WMS layer if no vector feature found
      if (!feature) {
        feature = await self.getWmsFeature(e.coordinate);
      }

      if (feature) {
        const props = feature.getProperties();
        const plotId = props.id || props.plot_id || props.land_id;
        const landId = props.land_id || props.dkbm || props.plot_id || props.id || plotId;
        const qsrxm = props.qsrxm || props.qsrmc || props.owner_name || '';
        const ownerId = props.qsrid || props.owner_id_card || props.person_id || props.nhdm || props.id_number_raw || props.id_number || '';
        const dkmc = props.dkmc || props.land_name || `${landId} (${qsrxm || '未命名'})`;
        const DL = props.DL || props.land_type || '';
        const mj = props.mj || props.area_mu || props.htmj || 0;
        const insuredFlag = props.bs === '1' || props.bs === 1;
        const bsValue = insuredFlag ? '1' : '0';
        const record = {
          ...props,
          plot_id: plotId,
          land_id: landId,
          land_name: dkmc,
          ownerName: qsrxm,
          owner_name: qsrxm,
          area_mu: mj,
          land_type: DL,
          dkmc,
          DL,
          qsrxm,
          mj,
          dkbm: props.dkbm,
          qsrid: ownerId,
          insured: insuredFlag ? 1 : 0,
          match: props.is_valid ? 'OK' : 'MISMATCH',
          is_insured: insuredFlag ? 1 : 0,
          bs: bsValue,
          fromMap: true
        };

        self.clickedPlotInfo = record;
        self.trusteePopup(e.coordinate, record);
      } else {
        // Clear selection if clicked on empty space?
        // Better not, user might be panning.
      }
    },
    // fetchPolicyInfo removed

    // 制图风格，标注内容要从要素中获取，每个要素的name_ch属性不同，所以制图风格是方法，而不是静态的
    polygonStyleFunction (feature) {
      'use strict';
      return new Style({
        stroke: new Stroke({
          color: 'rgba(0,255,0,1)',
          width: 2
        })
      });
    },

    async trusteeSubmit () {
      if (this.trusteeLands.length === 0) {
        this.$notify({
          title: 'ERROR!',
          text: '请先选择地块！'
        });
      }
    },
    /**
     * Show the popup for the trustee lands
     *
     * @param  {ol/coordinate} coordinate The coordinate of the popup
     * @param  {ol/Feature} record The feature of the popup
     */
    trusteePopup (coordinate, record) {
      const overlayId = 'ks-popup-tooltip';
      record.objectType = 'insure_apply_plot';
      // show popup and update content
      WguEventBus.$emit(overlayId + '-update-overlay', true, coordinate, {
        feature: record,
        layer: this.layer,
        hoverAttribute: true
      });
    },
    onPopupAddToSearchList (record) {
      if (!record || !record.land_id) return;
      const existingIdx = this.trusteeLands.findIndex(item => item.land_id === record.land_id);
      if (existingIdx === -1) {
        this.trusteeLands.push(record);
      } else {
        this.trusteeLands.splice(existingIdx, 1, { ...this.trusteeLands[existingIdx], ...record });
      }
      this.clickedPlotInfo = record;
    },
    /**
     * Refresh the trustee lands
     */
    handleRefreshTrusteeLands () {
      this.trusteeLands = [];
      const landLayer = this.map.getLayers().getArray().find(layer => layer.get('lid') === 'landowner');
      if (landLayer) {
        // const landLayerSource = landLayer.getSource();
        // landLayerSource.setSource(null);
      }
    },
    handleRemoveTrusteeLand (record) {
      if (!record) return;

      const plotId = record.plot_id || record.id || null;
      const landId = record.land_id || null;

      this.trusteeLands = this.trusteeLands.filter(item => {
        const itemPlotId = item.plot_id || item.id || null;
        const samePlot = plotId && itemPlotId && itemPlotId === plotId;
        const sameLand = landId && item.land_id && item.land_id === landId;
        return !(samePlot || sameLand);
      });

      if (this.clickedPlotInfo) {
        const clickedPlotId = this.clickedPlotInfo.plot_id || this.clickedPlotInfo.id || null;
        const clickedLandId = this.clickedPlotInfo.land_id || null;
        const sameClickedPlot = plotId && clickedPlotId && clickedPlotId === plotId;
        const sameClickedLand = landId && clickedLandId && clickedLandId === landId;
        if (sameClickedPlot || sameClickedLand) {
          this.clickedPlotInfo = null;
        }
      }
    },
    startBoxSelectAdd () {
      if (this.insureType !== 'searchPlot' || !this.map) {
        return;
      }

      if (this.dragBoxInteraction) {
        this.map.removeInteraction(this.dragBoxInteraction);
        this.dragBoxInteraction = null;
      }

      this.dragBoxInteraction = new DragBox();
      this.dragBoxInteraction.on('boxend', () => {
        const extent = this.dragBoxInteraction?.getGeometry?.()?.getExtent?.();
        if (!extent) return;

        const addedCount = this.addPlotsFromExtent(extent);
        if (this.$notify) {
          this.$notify({
            title: '提示',
            text: addedCount > 0 ? `已添加 ${addedCount} 个地块到搜索列表` : '框选范围内无可添加地块'
          });
        }

        if (this.map && this.dragBoxInteraction) {
          this.map.removeInteraction(this.dragBoxInteraction);
          this.dragBoxInteraction = null;
        }
      });

      this.map.addInteraction(this.dragBoxInteraction);
      if (this.$notify) {
        this.$notify({
          title: '提示',
          text: '请在地图上拖拽框选地块'
        });
      }
    },
    addPlotsFromExtent (extent) {
      if (!this.map || !extent) return 0;

      const selectableLayerIds = new Set(['plots-layer', 'insured-plots-layer', 'uninsured-plots-layer', 'plot-boundaries-layer']);
      const dedupedPlots = new Map();

      this.map.getLayers().getArray().forEach((layer) => {
        if (!layer || typeof layer.get !== 'function') return;
        const lid = layer.get('lid');
        if (!selectableLayerIds.has(lid)) return;

        const source = typeof layer.getSource === 'function' ? layer.getSource() : null;
        if (!source || typeof source.forEachFeatureIntersectingExtent !== 'function') return;

        source.forEachFeatureIntersectingExtent(extent, (feature) => {
          const props = typeof feature.getProperties === 'function' ? feature.getProperties() : null;
          const normalized = this.normalizePlotRecord(props || {});
          if (!normalized) return;
          if (normalized.bs === '1') return;
          dedupedPlots.set(normalized.land_id, normalized);
        });
      });

      let addedCount = 0;
      dedupedPlots.forEach((plot) => {
        const existingIdx = this.trusteeLands.findIndex(item => item.land_id === plot.land_id);
        if (existingIdx === -1) {
          this.trusteeLands.push(plot);
          addedCount += 1;
        } else {
          this.trusteeLands.splice(existingIdx, 1, { ...this.trusteeLands[existingIdx], ...plot });
        }
      });

      if (dedupedPlots.size > 0) {
        this.clickedPlotInfo = dedupedPlots.values().next().value || null;
      }

      return addedCount;
    },
    normalizePlotRecord (props) {
      if (!props || typeof props !== 'object') return null;

      const plotId = props.id || props.plot_id || props.land_id || null;
      const landId = props.land_id || props.dkbm || props.plot_id || props.id || null;
      if (!landId) return null;

      const bsRaw = String(props.bs ?? '').trim();
      const insured = bsRaw === '1' || bsRaw === '1.0' || bsRaw === '1.00';
      const qsrxm = props.qsrxm || props.qsrmc || props.owner_name || '';

      return {
        ...props,
        plot_id: plotId,
        land_id: landId,
        land_name: props.dkmc || props.land_name || `${landId} (${qsrxm || '未命名'})`,
        ownerName: qsrxm,
        owner_name: qsrxm,
        area_mu: props.mj || props.area_mu || props.htmj || 0,
        land_type: props.DL || props.land_type || '',
        dkmc: props.dkmc || props.land_name || '',
        DL: props.DL || props.land_type || '',
        qsrxm,
        mj: props.mj || props.area_mu || props.htmj || 0,
        dkbm: props.dkbm,
        qsrid: props.qsrid || props.owner_id_card || props.person_id || props.nhdm || props.id_number_raw || props.id_number || '',
        insured: insured ? 1 : 0,
        match: props.is_valid ? 'OK' : 'MISMATCH',
        is_insured: insured ? 1 : 0,
        bs: insured ? '1' : '0',
        fromMap: true
      };
    }
  }
}
</script>
<style scoped>
.insure-panel {
  width: 100%;
}
</style>
